import surveyNameFormFieldName from 'config/surveyNameFormFieldName';

export default {
  name: {
    formFieldName: surveyNameFormFieldName,
    errors: {
      Required: 'Template name required',
      Pattern: 'Invalid template name',
      Unique: 'Template name already used',
      MaxLength: 'Maximum name length exceeded',
    },
  },
};
